module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/gallery2-6e71aa75171de4254d3b55a980f25595.jpg";